module.exports = __webpack_public_path__ + "img/iceberg.cd0747b9.svg";